import { defineComponent, onMounted, ref } from "vue";
import FilterBar from "./filter-bar.vue";
export default defineComponent({
    components: {
        FilterBar: FilterBar
    },
    props: {
        config: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var formConfig = {
            inline: true
        };
        var isInit = ref(true);
        var visible = ref(true);
        var handleChange = function(value) {
            if (!isInit.value) {
                props.config.handleChange(value);
            }
        };
        onMounted(function() {
            setTimeout(function() {
                isInit.value = false;
            }, 300);
        });
        return {
            formConfig: formConfig,
            handleChange: handleChange,
            visible: visible
        };
    }
});
